/* eslint-disable camelcase */
import api from './axios'
import { Property } from './properties'

export interface HeroItem {
  position: number
  property_id: number
  property: Property
}

export const heroApi = {
  // ── Public ───────────────────────────────────────────────────────────────
  getHeroProperties () {
    return api.get<{ data: Property[] }>('/hero-properties')
  },

  // ── Admin ────────────────────────────────────────────────────────────────
  adminGetHeroProperties () {
    return api.get<{ data: HeroItem[] }>('/admin/hero-properties')
  },

  adminUpdateHeroProperties (propertyIds: number[]) {
    return api.put<{ message: string; data: number[] }>('/admin/hero-properties', {
      property_ids: propertyIds
    })
  }
}
